import React from 'react';

const PrintStyles: React.FC = () => (
  <style>
    {`
      @media print {
        @page {
          size: A4 portrait;
        }
        body * {
          visibility: hidden;
        }
        #printable-report, #printable-report * {
          visibility: visible;
        }
        #printable-report {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
        }
        button, .MuiIconButton-root {
          display: none !important;
        }
        body, #printable-report, #printable-report * {
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
        }
        #printable-report table {
          background-color: #fff !important;
          border-color: #e0e0e0 !important;
        }
        #printable-report th {
          background-color: #f5f5f5 !important;
          color: #222 !important;
        }
        #printable-report td {
          background-color: #fff !important;
          color: #222 !important;
        }
      }
    `}
  </style>
);

export default PrintStyles;